/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'message': {
    width: 214.063,
    height: 200,
    viewBox: '0 0 1096 1024',
    data: '<defs/><path pid="0" d="M849.214 0H1.766v776.828l180.082-211.862h667.366V0zM178.317 353.103a70.62 70.62 0 1170.62-70.62 70.62 70.62 0 01-70.62 70.62zm247.173 0a70.62 70.62 0 1170.62-70.62 70.62 70.62 0 01-70.62 70.62zm247.172 0a70.62 70.62 0 1170.62-70.62 70.62 70.62 0 01-70.62 70.62zm247.172-176.551v459.034H248.938v176.552h667.365L1096.386 1024V176.552H919.834z"/>'
  }
})
